import type { AppRole } from "@/lib/domainTypes";

const BLOG_AUTHOR_EMAILS = ["josphmatha06@hmail.com"];

const normalizeEmail = (value?: string | null) => String(value || "").trim().toLowerCase();

export const canAccessDashboardBlog = (role: AppRole, email?: string | null) => {
  if (["admin", "accountant"].includes(String(role || "").toLowerCase())) {
    return true;
  }

  return BLOG_AUTHOR_EMAILS.includes(normalizeEmail(email));
};

export const getBlogAuthorEmails = () => [...BLOG_AUTHOR_EMAILS];
